import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalendarCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calendar-check, date-check"} maskId="square-filled-radius-0-stroke-1-IconCalendarCheck"><path d="M8 2H7V4H3V21H12V20H4V9H20V13H21V4H17V2H16V4H8V2Z" fill="currentColor"/><path d="M22.1977 15.4123L21.4084 14.7983L16.7875 20.7395L14.5061 18.3929L13.7891 19.09L16.8714 22.2604L22.1977 15.4123Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalendarCheck;
